import { render, staticRenderFns } from "./SLWidget.vue?vue&type=template&id=4d44d8bc&scoped=true&"
import script from "./SLWidget.vue?vue&type=script&lang=js&"
export * from "./SLWidget.vue?vue&type=script&lang=js&"
import style0 from "./SLWidget.vue?vue&type=style&index=0&id=4d44d8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d44d8bc",
  null
  
)

export default component.exports